const TUTORIAL_STEPS = [
    // Step 1: Sidebar welcome
    {
        target: '[data-tour="sidebar"]',
        title: 'Welcome to Multiply!',
        content: 'Multiply is your AI-powered sales training platform. Murphy, your AI coach, will watch your practice recordings, grade your performance, and give you detailed feedback to help you improve. Use this sidebar to navigate between sections.',
        placement: 'right-start',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 2: Stats overview
    {
        target: '[data-tour="stats-overview"]',
        title: 'Your Progress',
        content: 'Track your training at a glance: total sessions completed, your current weekly streak, and progress toward your weekly practice goal.',
        placement: 'bottom',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 3: Training grid
    {
        target: '[data-tour="training-grid"]',
        title: 'Training Cards',
        content: 'These are your core training types. Standard mode is a straight-through pitch recording. Interactive mode adds Murphy as a live participant who interrupts with questions, just like a real prospect would. The more you practice, the better you get!',
        placement: 'top',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 4: First training card
    {
        target: '[data-tour="training-card-first"]',
        title: 'Start a Recording',
        content: 'Click "Record Standard" for a straight pitch, or "Record Interactive" to practice with Murphy asking questions mid-presentation. After each recording, Murphy analyzes your pitch against your company\'s messaging and gives you a grade with specific feedback on what to improve.',
        placement: 'right',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 5: Response training
    {
        target: '[data-tour="response-training"]',
        title: 'Response Training',
        content: 'These are your defensive training modes. Messaging Defense generates realistic prospect objections from your company profile so you can practice thinking on your feet. Objection Handling fires Q&A library questions at you. Document Defense lets you upload any document and Murphy tests your knowledge of it.',
        placement: 'top',
        page: '/dashboard',
        disableBeacon: true,
    },
    // Step 6: My Reports nav -> navigates to reports
    {
        target: '[data-tour="nav-my-reports"]',
        title: 'My Reports',
        content: 'After each recording, Murphy generates a detailed assessment with a grade, positives, and areas for improvement. My Reports is where you review all your past assessments and track your progress over time.',
        placement: 'right',
        page: '/dashboard',
        navigateAfter: '/my-assessments-report',
        disableBeacon: true,
    },
    // Step 7: Reports page content
    {
        target: '[data-tour="reports-page"]',
        title: 'Assessment History',
        content: 'Click any assessment to see Murphy\'s full feedback: what you did well, what to improve, and your grade. Green means great (65+), yellow means good (50-64), and red means keep practicing. Your goal is to turn those reds and yellows into greens!',
        placement: 'right',
        disableScrolling: true,
        page: '/my-assessments-report',
        disableBeacon: true,
    },
    // Step 8: My Meetings nav -> navigates to my-meetings
    // (live-meetings only — filtered out when company.liveMeetingsEnabled is off)
    {
        target: '[data-tour="nav-my-meetings"]',
        title: 'My Meetings',
        content: "Multiply doesn't just grade practice pitches — it can also sit in on your real sales calls. My Meetings is where you'll find recaps and coaching feedback for every live call Murphy has joined.",
        placement: 'right',
        page: '/my-assessments-report',
        navigateAfter: '/live-meetings',
        disableBeacon: true,
        feature: 'liveMeetings',
    },
    // Step 9: My Meetings page content
    // (live-meetings only — filtered out when company.liveMeetingsEnabled is off)
    {
        target: '[data-tour="my-meetings-page"]',
        title: 'Your Live Meetings',
        content: "To have Murphy join a live call, just invite murphy@askmultiply.com to your calendar event — that's it. Murphy joins the meeting, transcribes it, identifies the participants, and emails you a recap with grading-style feedback once it's done. If you manage a team, you'll also see a toggle near the top to switch between your meetings and your team's meetings. Murphy doesn't store recordings or train on your calls — but keep him out of conversations that touch PII, HR, or anything confidential. Remove murphy@askmultiply.com from a meeting and he'll drop off.",
        placement: 'right',
        disableScrolling: true,
        page: '/live-meetings',
        disableBeacon: true,
        feature: 'liveMeetings',
    },
    // Step 10: Business-data sidebar group -> navigates to company
    // When the live-meetings steps are filtered out, the prior step (Reports)
    // leaves us on /my-assessments-report and doesn't navigate, so this step is
    // shown there instead of /my-meetings (its target is a sidebar item present
    // on every page).
    {
        target: '[data-tour="nav-business-data"]',
        title: 'Company Info',
        content: 'These four pages — Company, Offerings, General Asks, and Objection Handling — are Murphy\'s training inputs. Murphy uses all of them to grade your pitches, so the more complete and accurate they are, the better your feedback will be. Let\'s walk through them.',
        placement: 'right',
        page: '/live-meetings',
        pageWhenNoLiveMeetings: '/my-assessments-report',
        navigateAfter: '/company',
        disableBeacon: true,
    },
    // Step 11: Company page content
    {
        target: '[data-tour="company-page"]',
        title: 'Company Overview',
        content: 'This is the information you need to become conversationally confident in. Background, differentiators, addressable problems, competitors, and prospect profile are all used when Murphy grades your pitches.',
        placement: 'right',
        disableScrolling: true,
        page: '/company',
        navigateAfter: '/offerings',
        disableBeacon: true,
    },
    // Step 12: Offerings page
    {
        target: '[data-tour="offerings-page"]',
        title: 'Offerings',
        content: 'These are your products and services with their key differentiators. Murphy references this content when grading your pitches to check whether you\'re covering the right talking points for each offering.',
        placement: 'right',
        disableScrolling: true,
        page: '/offerings',
        navigateAfter: '/objection-handling',
        disableBeacon: true,
    },
    // Step 13: Objection Handling page
    {
        target: '[data-tour="qa-page"]',
        title: 'Objection Handling',
        content: 'This is your library of common objections and ideal responses. Murphy uses these during interactive sessions to test you with real objections. At higher training levels, Murphy will fire these at you mid-pitch to simulate a real prospect.',
        placement: 'right',
        disableScrolling: true,
        page: '/objection-handling',
        disableBeacon: true,
    },
    // Step 14: Training Hub nav
    {
        target: '[data-tour="nav-train"]',
        title: 'Training Hub',
        content: 'The Training Hub has all session types: Pitch Training (Levels 1-2), Messaging Defense, Objection Handling, and Document Defense. Start with Level 1 Elevator Pitch and work your way up!',
        placement: 'right',
        page: '/objection-handling',
        disableBeacon: true,
    },
    // Step 15: Settings nav -> navigates to profile
    {
        target: '[data-tour="nav-profile"]',
        title: 'Settings',
        content: 'One last stop. Your Settings page is where you control how Murphy refers to you and what gets shared from your meeting reports.',
        contentWhenNoLiveMeetings: 'One last stop. Your Settings page is where you control how Murphy refers to you.',
        placement: 'right',
        page: '/objection-handling',
        navigateAfter: '/profile',
        disableBeacon: true,
    },
    // Step 16: Settings page content (Gender + Report Sharing)
    // The Report Sharing panel is itself gated on live meetings, so drop the
    // sharing copy when the feature is off.
    {
        target: '[data-tour="settings-form"]',
        title: 'Your Profile & Sharing',
        content: 'Murphy infers your gender from your name. If it ever gets it wrong, set Gender here and Murphy will use those pronouns from then on. The Report Sharing controls below let you decide whether to email yourself a recap of each meeting, whether external participants can view a redacted version of the report, and whether they get notified when access is granted.',
        contentWhenNoLiveMeetings: 'Murphy infers your gender from your name. If it ever gets it wrong, set Gender here and Murphy will use those pronouns from then on.',
        placement: 'right',
        disableScrolling: true,
        page: '/profile',
        disableBeacon: true,
    },
    // Step 17: Final -> back to dashboard
    {
        target: '[data-tour="nav-dashboard"]',
        title: 'You\'re Ready!',
        content: 'That\'s the tour! Head back to your Dashboard, where your Training Plan tells you exactly what to practice each day. Good luck!',
        placement: 'right',
        page: '/profile',
        navigateAfter: '/dashboard',
        isLastStep: true,
        disableBeacon: true,
    },
];

/**
 * Build the tutorial step list for the current company.
 *
 * When live meetings are disabled (company.liveMeetingsEnabled is false):
 *  - steps tagged `feature: 'liveMeetings'` are removed, and
 *  - any remaining step's `pageWhenNoLiveMeetings` / `contentWhenNoLiveMeetings`
 *    overrides are applied, so the navigation chain and copy stay correct.
 */
export const getTutorialSteps = (liveMeetingsEnabled) => {
    if (liveMeetingsEnabled) return TUTORIAL_STEPS;
    return TUTORIAL_STEPS
        .filter(step => step.feature !== 'liveMeetings')
        .map(step => {
            if (!step.pageWhenNoLiveMeetings && !step.contentWhenNoLiveMeetings) return step;
            return {
                ...step,
                ...(step.pageWhenNoLiveMeetings ? { page: step.pageWhenNoLiveMeetings } : {}),
                ...(step.contentWhenNoLiveMeetings ? { content: step.contentWhenNoLiveMeetings } : {}),
            };
        });
};

export default TUTORIAL_STEPS;
